import React from 'react';
import AMPPage from '../AMPPage';
import AMPPageHeader from '../AMPPageHeader';
import AMPPageSection from '../AMPPageSection';

export default function PrivacyPolicyPage() {
  return (
    <AMPPage>
      <AMPPageHeader title="Anchor FM Inc." subtitle="Privacy Policy" />
      <AMPPageSection>
        <p>Date of Last Revision: May 23, 2018</p>
        <h3 style={{ marginBottom: '16px' }}>Our Policy</h3>
        <div
          style={{
            textAlign: 'justify',
            fontFamily: 'Times New Roman',
            lineHeight: 'normal',
            fontSize: '12px',
          }}
        >
          <p>
            <span>
              Welcome to Anchor FM Inc. (“
              <b>Anchor</b>
              ”, “<b>we</b>
              ”, “<b>us</b>” and/or “<b>our</b>
              ”) Privacy Policy. Our services are designed to offer users
              (collectively, “<b>Users</b>
              ,” “<b>you</b>
              ,” or “<b>your</b>
              ”) the opportunity to easily create and share audio recordings
              with other Users (“
              <b>Services</b>
              ”). The Services are provided to you through our website (“
              <b>Site</b>
              ”) and mobile application (“
              <b>App</b>
              ”).
            </span>
          </p>

          <p>
            <span>
              This Privacy Policy explains what personal data we collect through
              the Services, how we use and share that data, and your choices
              concerning our data practices. This Privacy Policy forms part of
              our Terms of Use, which are available at:{' '}
            </span>
            <a href="https://anchor.fm/tos">
              <span>https://anchor.fm/tos</span>
            </a>
            <span>. </span>
          </p>

          <p>
            <span>
              By providing us with your personal data when using the Services,
              you agree to the practices described in this Privacy Policy. If
              you do not agree to this Privacy Policy, please do not access or
              use the Services.
            </span>
          </p>

          <p>
            <b>
              <span>INFORMATION WE COLLECT</span>
            </b>
          </p>

          <p>
            <span>
              When you interact with our Site or App, we collect information
              that, alone or in combination with other information, could be
              used to identify you (“
              <b>Personal Data</b>
              ”)
            </span>
          </p>

          <p>
            <b>
              <span>
                1.
                <span />
              </span>
            </b>
            <b>
              <span>Personal Data You Provide Us</span>
            </b>
          </p>

          <p>
            <b>
              <span />
            </b>
          </p>

          <p>
            <b>
              <span>
                A.
                <span />
              </span>
            </b>
            <b>
              <span>Account Information</span>
            </b>
          </p>

          <p />

          <p>
            <span>
              Some information is required to create an account on our Services,
              such as your name, email address, password, location. You may also
              choose to provide other types of information to make public on the
              Services, such as a profile photo, biography, country information,
              your website, and community username.
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <b>
              <span>
                B.
                <span />
              </span>
            </b>
            <b>
              <span>Social Media</span>
            </b>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              You may connect to the Services using credentials from social
              media services such as Facebook or Twitter (“
              <b>Social Media Services</b>
              ”). When you provide Anchor access to your Social Media Services
              account, we will collect relevant information necessary to enable
              the Services to access that Social Media Service, however you will
              provide your login information, like your password, directly to
              such Social Media Service (and not to Anchor).
            </span>
          </p>

          <p>
            <span>
              To access your Social Media Services account, we provide a link
              that directs you to a Social Media Service, where you may access
              the Services directly. As part of the integration with the
              Services, the Social Media Service will provide Anchor with access
              to certain information that you have provided to such Social Media
              Service, including for example to post-related meta data from your
              Twitter feed or Facebook wall (such as post type, date of
              creation, date of update, post creator, permanent link, and the
              number of “Likes” and “Comments”), and “friends” or other Users
              you are “following”.{' '}
            </span>
          </p>

          <p>
            <span>
              Anchor does not download, save, or store your photos, videos, or
              status messages posted on your Social Media Services accounts
              unless you grant us permission to do so. We will use, store and
              disclose such information in accordance with this Privacy Policy
              and, if and to the extent applicable, the policies of such Social
              Media Services.{' '}
            </span>
          </p>

          <p>
            <span>
              When you elect to access and use the Social Media Services, you
              will be sharing your information (which will include personal
              information if you elect to share such information) with those
              Social Media Services and others on the Social Media Services
              platform. We are not responsible for the privacy practices of
              Social Media Services and any the information you share with them
              is subject to their privacy policies and terms of service. As a
              result, Anchor shall not have any liability or responsibility for
              the privacy practices or other actions of Social Media Services
              that may be enabled within or otherwise accessible through the
              Services.
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              You may be able to adjust your privacy settings with these Social
              Media Services to control what information the services disclose
              to other entities, including Anchor. We suggest checking the
              privacy policies of the Social Media Services concerning their
              privacy settings and controls.{' '}
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <b>
              <span>
                C.
                <span />
              </span>
            </b>
            <b>
              <span>Posts, Following, Lists and other Public Information</span>
            </b>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              The Services are primarily designed to help you share information
              with the world. Most of the information you provide us through the
              Services is information you are asking us to make public.{' '}
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              Your{' '}
              <b>
                <i>public information</i>
              </b>{' '}
              includes the (i) messages you post; the metadata provided with
              such posts, such as when you posted and the application you used
              to post; (ii) language, country, and time zone associated with
              your account; and (iii) lists you create, people you follow, posts
              you mark as likes, and many other bits of information that result
              from your use of the Services. Our default is almost always to
              make the information you provide through the Services public for
              as long as you do not delete it.{' '}
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              The Services broadly and instantly disseminate your public
              information to a wide range of users, customers, and services. For
              instance, your public user profile information and public posts
              are immediately delivered via RSS feeds and our APIs to our
              partners and other third parties, including search engines,
              developers, and publishers that integrate the Services content
              into their services, and institutions such as universities and
              public health agencies that analyze the information for trends and
              insights. When you share information or content via the Services,
              you should think carefully about what you are making public.
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <b>
              <span>
                D.
                <span />
              </span>
            </b>
            <b>
              <span>Location Information</span>
            </b>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              We may receive information about your location. For example, you
              may choose to publish your location in your posts and in your
              Anchor profile and when you set your trend location on the
              Services. We may also determine location by using other data from
              your device, such as precise location information from GPS,
              information about wireless networks or cell towers near your
              mobile device, or your IP address.{' '}
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <b>
              <span>
                E.
                <span />
              </span>
            </b>
            <b>
              <span>Additional Information</span>
            </b>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              You may choose to upload your address book so that we can help you
              find Users you know or help other Users find you. We may later
              make suggestions to you and other Users based on imported address
              book contacts. You can delete your imported address book contacts
              at any time.{' '}
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              If you email us, we may keep your message, email address and
              contact information to respond to your request. If you connect
              your account on our Services to your account on another service in
              order to cross-post between our Services and that service, the
              other service may send us your registration or profile information
              on that service and other information that you authorize. This
              information enables cross-posting, helps us improve the Services,
              and is deleted from our Services within a few weeks of your
              disconnecting your account on the other service from the Services
              account.
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              We also collect information you choose to provide to us when you
              complete any “free text” boxes in our forms (for example, support
              request or survey submission).
            </span>
          </p>

          <p>
            <b>
              <span>
                2.
                <span />
              </span>
            </b>
            <b>
              <span>Information We Receive From Your Use of Our Services</span>
            </b>
          </p>

          <p>
            <span>
              When you use the Services, the following information is created
              and automatically logged in our systems:
            </span>
          </p>

          <p>
            <b>
              <span>Log data</span>
            </b>
            <span>
              : Information (“log data”) that your browser automatically sends
              whenever you visit the Site, or that the App automatically sends
              when you use them. Log data includes your Internet Protocol (“IP”)
              address (so we understand which country you are connecting from
              when you visit the Site), browser type and settings, the date and
              time of your request, and how you interacted with the Services.{' '}
            </span>
          </p>

          <p>
            <b>
              <span>Cookies:</span>
            </b>
            <span>
              {' '}
              Information from cookies stored on your device. Please see{' '}
              <a href="https://anchor.fm/privacy#contact">
                the “Cookies” section below
              </a>{' '}
              to learn more about how we use cookies and other technologies.
            </span>
          </p>

          <p>
            <b>
              <span>Device information</span>
            </b>
            <span>
              : Includes type of device you are using, operating system,
              settings, unique device identifiers, network information and other
              device-specific information. Information collected may depend on
              the type of device you use and its settings.{' '}
            </span>
          </p>

          <p>
            <b>
              <span>Usage Information</span>
            </b>
            <span>: </span>
            <span>
              We collect information about how you use our Services, such as the
              types of content that you view or engage with, the features you
              use, the actions you take, the other Users you interact with and
              the time, frequency and duration of your activities.
            </span>
          </p>

          <p>
            <b>
              <span>HOW WE USE INFORMATION</span>
            </b>
            <span />
          </p>

          <p>
            <span>We use your personal data for the following purposes:</span>
          </p>

          <p>
            <b>
              <span>To authenticate Users and provide the Service</span>
            </b>
            <span>. </span>
            <span>
              This processing is necessary to perform the contract with you.
            </span>
          </p>

          <p>
            <b>
              <span>
                As necessary for certain legitimate business interests
              </span>
            </b>
            <span>, which include the following</span>
            <span>:</span>
          </p>

          <p>
            <span>
              ·<span />
            </span>
            <span>
              To respond to your inquiries and fulfill your requests for
              products and services;
            </span>
          </p>

          <p>
            <span>
              ·<span />
            </span>
            <span>
              To customize our Services for you, including providing
              recommendations, personalized advertising and content (please read
              below to learn how we use Personal Data for targeted
              advertisement). For example, we use information on your use of
              Services features, including information that we obtain through
              cookies, to better understand your needs and interests in order to
              personalize your experience with our Services by presenting
              products and offers tailored to your interests. We use your public
              information and your location information (described above) to
              infer what topics you may be interested in, and to customize the
              content we show you, including ads, with more relevant content
              like local trends, stories, ads, and suggestions for people to
              follow;
            </span>
          </p>

          <p>
            <span>
              ·<span />
            </span>
            <span>
              To send administrative information to you, for example,
              information regarding the Site or the App, and changes to our
              terms, conditions, and policies;
            </span>
          </p>

          <p>
            <span>
              ·<span />
            </span>
            <span>
              To provide, maintain and improving the content and functionality
              of the Services.
            </span>{' '}
            <span>
              For example, we regularly fix bugs or user experience issues that
              may be tied to particular user accounts. We use cookies to analyze
              how Users interact with our Services. And that analysis can help
              us build better Services.
            </span>
          </p>

          <p>
            <span>
              ·<span />
            </span>
            <span>
              To conduct research, and provide reporting to third parties;
            </span>
          </p>

          <p>
            <span>
              ·<span />
            </span>
            <span>
              If you ask us to delete your data and we are required to fulfil
              your request, to keep basic data to identify you and prevent
              further unwanted processing;
            </span>
          </p>

          <p>
            <span>
              ·<span />
            </span>
            <span>To prevent fraud or criminal activity, misuses</span>{' '}
            <span>
              of our products or services, and ensure the security of our IT
              systems, architecture and networks;
            </span>
          </p>

          <p>
            <span>
              ·<span />
            </span>
            <span>
              To (a) comply with legal obligations and legal process, (b)
              respond to requests from public and government authorities
              including public and government authorities outside your country
              of residence; (c) enforce our Terms of Use; (d) protect our
              operations or those of any of our affiliates; (e) protect our
              rights, privacy, safety or property, and/or that of our
              affiliates, you or others; and (f) allow us to pursue available
              remedies or limit the damages that we may sustain, as required or
              permitted by the law.
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              For individuals in the EU, please see the “European Union (EU)
              Users” section below for information on what we mean by legitimate
              interests and your rights.
            </span>
          </p>

          <p>
            <b>
              <span>Marketing.</span>
            </b>
            <span>
              We may contact you to tell you about services or products we
              believe will be of interest to you. If we do, where required by
              law, for example if you are a User in the European Union (“
              <b>EU</b>
              ”),{' '}
            </span>
            <span>
              we will only send you marketing information if you consent to us
              doing so at the time you provide us with your Personal Data. You
              may opt-out of receiving such emails by following the instructions
              contained in each promotional email we send you or by updating
              your user settings. In addition, if at any time you do not wish to
              receive future marketing communications, please contact us at
              help@anchor.fm. We will continue to contact you via email
              regarding the provision of our Services and to respond to your
              requests
            </span>
            <span>.</span>
          </p>

          <p>
            <b>
              <span>Targeted Advertisement</span>
            </b>
            <span>
              . Anchor may display targeted advertisements based on Personal
              Data. Third parties (including ad serving companies) may assume
              that Users who interact with, view, or click targeted
              advertisements meet the targeting criteria (e.g., women ages 18–24
              from a particular geographic area). Anchor does not provide any
              Personal Data to the advertiser when a User interacts with or
              views a targeted advertisement. However, please be aware that by
              interacting with or viewing an advertisement the third party may
              make the assumption that you meet the targeting criteria used to
              display the advertisement.
            </span>
          </p>

          <p>
            <b>
              <span>SHARING AND DISCLOSURE OF INFORMATION</span>
            </b>
          </p>

          <p>
            <span>
              We may share or disclose your information at your direction, such
              as when you authorize a third-party service to access your account
              or when you voluntarily share information or content via the
              Services. Other Users may share or disclose information about you,
              such as when they mention you.
            </span>
          </p>

          <p>
            <span>
              There are certain circumstances in which we may share your
              Personal Data with certain third parties without further notice to
              you, unless required by the law, as set forth below:
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              ·<span />
            </span>
            <b>
              <span>Vendors and Service Providers:</span>
            </b>
            <span>
              To assist us in meeting business operations needs and to perform
              certain services and functions: providers of hosting, email
              communication and customer support services, analytics, marketing,
              advertising (for more details on the third parties that place
              cookies through the Site, please see{' '}
              <a href="https://anchor.fm/privacy#contact">
                the “Cookies” section below
              </a>
              ). Pursuant to our instructions, these parties will access,
              process or store Personal Data in the course of performing their
              duties to us.
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              ·<span />
            </span>
            <b>
              <span>Business Transfers:</span>
            </b>
            <span>
              {' '}
              If we are involved in a merger, acquisition, financing due
              diligence, reorganization, bankruptcy, receivership, sale of all
              or a portion of our assets, or transition of service to another
              provider, your Personal Data and other information may be
              transferred to a successor or affiliate as part of that
              transaction along with other assets.
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              ·<span />
            </span>
            <b>
              <span>Legal Requirements:</span>
            </b>
            <span>
              {' '}
              If required to do so by law or in the good faith belief that such
              action is necessary to (i) comply with a legal obligation, (ii)
              protect and defend our rights or property, (iii) act in urgent
              circumstances to protect the personal safety of Users of the Site
              or the App, or the public, or (iv) protect against legal
              liability.
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <b>
              <span>DATA RETENTION</span>
            </b>
          </p>

          <p>
            <b>
              <span />
            </b>
          </p>

          <p>
            <span>
              We will keep your Personal Data for as long as reasonably
              necessary for the purposes described in this Privacy Policy, while
              we have a legitimate business need to do so, or as required by law
              (e.g. for tax, legal, accounting or other purposes), whichever is
              the longer.
            </span>
          </p>

          <p />

          <p>
            <span>
              If you have elected to receive marketing communications from us,
              we retain information about your marketing preferences until you
              opt out of receiving these communications and in accordance with
              our policies.
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              To determine the appropriate retention period for your Personal
              Data, we will consider the amount, nature, and sensitivity of the
              Personal Data, the potential risk of harm from unauthorized use or
              disclosure of your Personal Data, the purposes for which we use
              your Personal Data and whether we can achieve those purposes
              through other means, and the applicable legal requirements. In
              some circumstances we may anonymize your Personal Data so that it
              can no longer be associated with you, in which case it is no
              longer Personal Data.
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <b>
              <span>UPDATE YOUR INFORMATION</span>
            </b>
          </p>

          <p>
            <b>
              <span />
            </b>
          </p>

          <p>
            <span>
              If you need to change or correct your Personal Data, or wish to
              have it deleted from our systems, you may{' '}
              <a href="https://anchor.fm/privacy#contact">contact us</a>. We
              will address your request as required by applicable law. You may
              also update your Personal Data from your user settings.
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <b>
              <span>CALIFORNIA PRIVACY DISCLOSURE </span>
            </b>
          </p>

          <p>
            <b>
              <span />
            </b>
          </p>

          <p>
            <b>
              <span>Do Not Track Signals</span>
            </b>
            <span>:</span>
            <span>
              The Site currently does not respond to “Do Not Track” (“
              <b>DNT</b>
              ”) signals and operates as described in this Privacy Policy
              whether or not a DNT signal is received. If we do respond to DNT
              signals in the future, we will update this Privacy Policy to
              describe how we do so.{' '}
            </span>
          </p>

          <p>
            <b />
          </p>

          <p>
            <b>EUROPEAN UNION (EU) USERS</b>
          </p>

          <p>
            <span />
          </p>

          <p>
            <b>
              <span>Scope</span>
            </b>
            <span>
              . This section applies if you are a User in the EU (for these
              purposes, reference to the EU also includes the European Economic
              Area countries of Iceland, Liechtenstein and Norway).
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <b>
              <span>Data Controller</span>
            </b>
            <span>
              . Anchor FM, Inc. is the data controller for processing Personal
              Data provided to us through the Services. To find out our contact
              details, please see the “Contact Us” section below, which also
              provides the contact details of our representative in the EU for
              purposes of the
            </span>{' '}
            <span>General Data Protection Regulation. </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <b>
              <span>Your Rights</span>
            </b>
            <span>
              . Subject to applicable EU law, you have the following rights in
              relation to your Personal Data:
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              -<span />
            </span>
            <b>
              <span>Right of access:</span>
            </b>
            <span>
              {' '}
              If you ask us, we will confirm whether we are processing your
              Personal Data and, if so, provide you with a copy of that Personal
              Data along with certain other details. If you require additional
              copies, we may need to charge a reasonable fee.
            </span>
          </p>

          <p>
            <span>
              -<span />
            </span>
            <b>
              <span>Right to rectification:</span>
            </b>
            <span>
              {' '}
              If your Personal Data is inaccurate or incomplete, you are
              entitled to ask that we correct or complete it. If we shared your
              Personal Data with others, we will tell them about the correction
              where possible. If you ask us, and where possible and lawful to do
              so, we will also tell you with whom we shared your Personal Data
              so you can contact them directly.
            </span>
          </p>

          <p>
            <span>
              -<span />
            </span>
            <b>
              <span>Right to erasure:</span>
            </b>
            <span>
              {' '}
              You may ask us to delete or remove your Personal Data, such as
              where you withdraw your consent. If we shared your data with
              others, we will tell them about the erasure where possible. If you
              ask us, and where possible and lawful to do so, we will also tell
              you with whom we shared your Personal Data with so you can contact
              them directly.
            </span>
          </p>

          <p>
            <span>
              -<span />
            </span>
            <b>
              <span>Right to restrict processing:</span>
            </b>{' '}
            <span>
              You may ask us to restrict or ‘block’ the processing of your
              Personal Data in certain circumstances, such as where you contest
              the accuracy of the data or object to us processing it (please
              read below for information on your right to object). We will tell
              you before we lift any restriction on processing. If we shared
              your Personal Data with others, we will tell them about the
              restriction where possible. If you ask us, and where possible and
              lawful to do so, we will also tell you with whom we shared your
              Personal Data so you can contact them directly.
            </span>
          </p>

          <p>
            <span>
              -<span />
            </span>
            <b>
              <span>Right to data portability: </span>
            </b>
            <span>
              You have the right to obtain your Personal Data from us that you
              consented to give us or that was provided to us as necessary in
              connection with our contract with you. We will give you your
              Personal Data in a structured, commonly used and machine-readable
              format. You may reuse it elsewhere.
            </span>
          </p>

          <p>
            <span>
              -<span />
            </span>
            <b>
              <span>Right to object:</span>
            </b>
            <span>
              {' '}
              You may ask us at any time to stop processing your Personal Data,
              and we will do so:
            </span>
          </p>
          <ul>
            <li>
              If we are relying on a legitimate interest to process your
              Personal Data -- unless we demonstrate compelling legitimate
              grounds for the processing or
            </li>

            <li>
              If we are processing your Personal Data for direct marketing.
            </li>
          </ul>

          <p>
            <span>
              -<span />
            </span>
            <b>
              <span>Right to withdraw consent:</span>
            </b>
            <span>
              If we rely on your consent to process your Personal Data, you have
              the right to withdraw that consent at any time. Withdrawal of
              consent will not affect any processing of your data before we
              received notice that you wished to withdraw consent.
            </span>
          </p>

          <p>
            <span>
              -<span />
            </span>
            <b>
              <span>
                Right to lodge a complaint with the data protection authority:
              </span>
            </b>
            <span>
              {' '}
              If you have a concern about our privacy practices, including the
              way we handled your Personal Data, you can report it to the data
              protection authority that is authorized to hear those concerns.
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              Please see{' '}
              <a href="https://anchor.fm/privacy#contact">
                the “Contact Us” section
              </a>{' '}
              below for information on how to contact us to exercise your
              rights.{' '}
            </span>
          </p>

          <p>
            <b>
              <span />
            </b>
          </p>

          <p>
            <b>
              <span>Legitimate Interest</span>
            </b>
            <span>
              . “Legitimate interests” means our interests in conducting our
              business, managing and delivering the best Services to you. This
              Privacy Policy describes when we process your Personal Data for
              our legitimate interests, what these interests are and your
              rights. We will not use your Personal Data for activities where
              the impact on you overrides our interests, unless we have your
              consent or those activities are otherwise required or permitted to
              by law.{' '}
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <b>
              <span>PUBLICLY POSTED INFORMATION</span>
            </b>
          </p>

          <p>
            <b>
              <span />
            </b>
          </p>

          <p>
            <span>
              This Privacy Policy shall not apply to any information you post to
              the public areas of the Services. Comments posted to public areas
              may be viewed, accessed, and used by third parties subject to
              those parties’ privacy practices and policies.
            </span>
          </p>

          <p>
            <u>
              <span>
                <span />
              </span>
            </u>
          </p>

          <p>
            <b>
              <span>CHILDREN</span>
            </b>
          </p>

          <p>
            <b>
              <span />
            </b>
          </p>

          <p>
            <span>
              Anchor does not knowingly collect Personal Data from children
              under the age of 13. If you have reason to believe that a child
              under the age of 13 has provided Personal Data to Anchor through
              the Services please{' '}
              <a href="https://anchor.fm/privacy#contact">contact us</a> and we
              will endeavor to delete that information from our databases.
            </span>
          </p>

          <p>
            <b>
              <span />
            </b>
          </p>

          <p>
            <b>
              <span>LINKS TO OTHER WEBSITES</span>
            </b>
          </p>

          <p>
            <b>
              <u>
                <span>
                  <span />
                </span>
              </u>
            </b>
          </p>

          <p>
            <span>
              The Site and the App may contain links to other websites not
              operated or controlled by us (“
              <b>Third Party Sites</b>
              ”), including the Social Media Services. The information that you
              share with Third Party Sites will be governed by the specific
              privacy policies and terms of service of the Third Party Sites and
              not by this Privacy Policy. By providing these links we do not
              imply that we endorse or have reviewed these sites. Please contact
              those sites directly for information on their privacy practices
              and policies.{' '}
            </span>
          </p>

          <p>
            <a name="30j0zll" />
            <span />
          </p>

          <p>
            <b>
              <span>COOKIES</span>
            </b>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>The Site uses cookies to</span>{' '}
            <span>
              operate and administer our Site and the Services, make it easier
              for you to use the Services during future visits and gather usage
              data on our Site or App.
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <b>
              <span>What Are Cookies</span>
            </b>
            <span>
              . A “cookie” is a piece of information sent to your browser by a
              website you visit. By choosing to use our the Site after having
              been notified of our use of cookies in the ways described in this
              Privacy Policy, and, in applicable jurisdictions, through notice
              and unambiguous acknowledgement of your consent, you agree to such
              use.{' '}
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              Some cookies expire after a certain amount of time, or upon
              logging out (session cookies), others remain on your computer or
              terminal device for a longer period (persistent cookies). Our Site
              uses first party cookies (cookies set directly by Anchor) as well
              as third party cookies, as described below.
            </span>
            <span> For more details on cookies please visit </span>
            <a href="http://www.allaboutcookies.org">
              <span>All About Cookies</span>
            </a>
            <span>.</span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <b>
              <span>Type of Cookies Used</span>
            </b>
            <span>. The Site uses the following technologies:</span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              -<span />
            </span>
            <b>
              <span>Strictly Necessary Cookies</span>
            </b>
            <span>
              : Used to provide Users with the Services available through our
              Site and to use some of their features, such as the ability to
              log-in and access to secure areas. These cookies are served by
              Anchor and are essential for using and navigating the Site.
              Without these cookies, basic functions of our Site would not work.
              Because these cookies are strictly necessary to deliver the Site
              and the Services, you cannot refuse them.
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              -<span />
            </span>
            <b>
              <span>Analytics/Performance</span>
            </b>
            <span>
              : Used to better understand the behavior of the Users on our Site
              and improve our Site accordingly, for example by making sure Users
              are finding what they need easily. The Site uses Google Analytics,
              a web analytics service provided by Google Inc. (“
              <b>Google</b>
              ”). The information collected by Google (including your IP
              address) will be transmitted to and stored by Google on servers in
              the United States (Google is certified to the Privacy Shield for
              data transfers). How long a Google Analytics cookie remains on
              your computer or device depends on what it is and what it is used
              for. Some Google Analytics cookies expire at the end of your
              browser session, whilst others can remain for up to two years. You
              can prevent your data from being collected by Google Analytics on
              our Site by downloading and installing the{' '}
            </span>
            <a href="https://tools.google.com/dlpage/gaoptout?hl=en">
              <span>Google Analytics Opt-out Browser Add-on</span>
            </a>{' '}
            <span>
              for your current web browser. For more information on Google
              Analytics privacy practices, read{' '}
            </span>
            <a href="https://support.google.com/analytics/answer/6004245?hl=en&amp;ref_topic=2919631">
              <span>here</span>
            </a>
            <span>. </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <b>
              <span>Your Choices</span>
            </b>
            <span>
              . On most web browsers, you will find a “help” section on the
              toolbar. Please refer to this section for information on how to
              receive a notification when you are receiving a new cookie and how
              to turn cookies off. Please see the links below for guidance on
              how to modify your web browser’s settings on the most popular
              browsers:
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              -<span />
            </span>
            <a href="http://windows.microsoft.com/en-gb/internet-explorer/delete-manage-cookies#ie=ie-11">
              <span>Internet Explorer</span>
            </a>
          </p>

          <p>
            <span>
              -<span />
            </span>
            <a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences?esab=a&amp;s=cookies&amp;r=6&amp;as=s">
              <span>Mozilla Firefox</span>
            </a>
          </p>

          <p>
            <span>
              -<span />
            </span>
            <a href="https://support.google.com/accounts/answer/61416?hl=en">
              <span>Google Chrome</span>
            </a>
          </p>

          <p>
            <span>
              -<span />
            </span>
            <a href="https://support.apple.com/kb/PH21411?viewlocale=en_US&amp;locale=en_US">
              <span>Apple Safari</span>
            </a>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              Please note that if you limit the ability of websites to set
              cookies, you may be unable to access certain parts of the Site and
              you may not be able to benefit from the full functionality of the
              Site.
            </span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span>
              If you access the Site on your mobile device, you may not be able
              to control tracking technologies through the settings.
            </span>
          </p>

          <p>
            <b>
              <span>THIRD PARTY WEBSITES AND APPLICATIONS</span>
            </b>
          </p>

          <p>
            <span>
              This Privacy Policy only applies to the Services. The Services may
              contain links to other websites not operated or controlled by
              Anchor (the “<b>Third Party Sites</b>
              ”). We do not own, control or operate such linked sites, and we
              are not responsible for the privacy policies or practices of such
              linked sites. Privacy policies and practices for such linked sites
              may differ from this Privacy Policy and our practices. We
              encourage you to read the privacy policies of such linked sites
              before disclosing personal information on Third Party Sites.
            </span>
          </p>

          <p>
            <b>
              <span>LINKS TO OTHER WEB SITES</span>
            </b>
          </p>

          <p>
            <span>
              This Privacy Policy applies only to the Services. The Services may
              contain links to other web sites not operated or controlled by
              Anchor (the “<b>Third Party Sites</b>
              ”). The policies and procedures we described here do not apply to
              the Third Party Sites. The links from the Services do not imply
              that Anchor endorses or has reviewed the Third Party Sites. We
              suggest contacting those sites directly for information on their
              privacy policies.
            </span>
          </p>

          <p>
            <b>
              <span>SECURITY</span>
            </b>
          </p>

          <p>
            <span>
              You use Services at your own risk. Anchor takes steps to protect
              the Personal Data provided via the Services from loss, misuse, and
              unauthorized access, disclosure, alteration, or destruction.
              However, no Internet or e-mail transmission is ever fully secure
              or error free. In particular, e-mail sent to or from the Services
              may not be secure. Therefore, you should take special care in
              deciding what information you send to us via e-mail. Please keep
              this in mind when disclosing any Personal Data to Anchor via the
              internet. We cannot control the actions of other Users with whom
              you may choose to share information. Therefore, we cannot, and do
              not, guarantee that information or content posted by a User on or
              through the Services will not be viewed by unauthorized persons.
              We are not responsible for circumvention of any privacy settings
              or security measures contained on the Services or Social Media
              Services.
            </span>
          </p>

          <p>
            <b>
              <span>OTHER TERMS AND CONDITIONS</span>
            </b>
          </p>

          <p>
            <span>
              Your access to and use of the Services is subject to any
              additional terms applicable to such Services that may be posted on
              the Services from time to time, including without limitation,
              Anchor’s Terms of Use available at{' '}
            </span>
            <a href="https://anchor.fm/tos">
              <span>https://anchor.fm/tos</span>
            </a>
            <span>.</span>
          </p>

          <p>
            <b>
              <span>CHANGES TO THE PRIVACY POLICY</span>
            </b>
          </p>

          <p>
            <span>
              The Services and our business may change from time to time. As a
              result we may change this Privacy Policy at any time and when we
              do we will post an updated version on this page, unless another
              type of notice is required by the applicable law. By continuing to
              use the Site and the App or providing us with information after we
              have posted an updated Privacy Policy, or notified you if
              applicable, you consent to the revised Privacy Policy and
              practices described in it.{' '}
            </span>
          </p>

          <p>
            <b>
              <span>INTERNATIONAL USERS</span>
            </b>
          </p>

          <p>
            <span>
              Anchor is based in the United States. If you are accessing our
              Services from the European Union or other regions with laws
              governing data collection and use, please note that your Personal
              Data will be transmitted to our servers in the United States and
              the data may be transmitted to our service providers supporting
              our business operations (described above). The United States may
              have data protection laws less stringent than or otherwise
              different from the laws in effect in the country in which you are
              located. Where we transfer your Personal Data out of the EU we
              will take steps to ensure that your Personal Data receives an
              adequate level of protection where it is processed and your rights
              continue to be protected.
            </span>
          </p>

          <p>
            <span>
              By providing your information to the Services you agree to the
              transfer of your information to the United States and processing
              globally in accordance with this Privacy Policy.
            </span>
          </p>

          <p>
            <a name="contact" />
            <b>
              <span>CONTACT US</span>
            </b>
          </p>

          <p>
            <span>
              Please feel free to contact us if you have any questions about
              Anchor’s Privacy Policy or the information practices of the
              Services.
            </span>
          </p>

          <p>
            <span>
              You may contact us as follows: You may send an email to{' '}
            </span>
            <a href="mailto:help@anchor.fm">
              <span>help@anchor.fm</span>
            </a>
            <span>, or send mail to:</span>
          </p>

          <p>
            <span>
              <br />
              Anchor FM Inc.
              <br />
              c/o Privacy Dept.
              <br />
              41 West 25th Street, 4th Floor
              <br />
              New York, NY 10010
            </span>
          </p>

          <p>
            <span>
              If you are an individual in the EU, you can also contact VeraSafe,
              who has been appointed as Anchor’s representative in the EU
              pursuant to Article 27 of the General Data Protection Regulation,
              only on matters related to the processing of personal data. To
              make such an inquiry, please contact VeraSafe using this contact
              form:{' '}
            </span>
            <a href="https://www.verasafe.com/privacy-services/contact-article-27-representative">
              <span>
                https://www.verasafe.com/privacy-services/contact-article-27-representative
              </span>
            </a>
            <span>. Alternatively, VeraSafe can be contacted at:</span>
          </p>

          <p>
            <span />
          </p>

          <p>
            <span />
          </p>

          <table border="0" cellSpacing="0" cellPadding="0">
            <tbody>
              <tr>
                <td width="239" valign="top">
                  <p>
                    <span>VeraSafe Czech Republic s.r.o</span>
                  </p>
                  <p>
                    <span>Klimentská 46</span>
                  </p>
                  <p>
                    <span>Prague 1, 11002</span>
                  </p>
                  <p>
                    <span>Czech Republic</span>
                  </p>
                </td>
                <td width="239" valign="top">
                  <p>
                    <span>VeraSafe Ireland Ltd</span>
                  </p>
                  <p>
                    <span>Unit 3D North Point House</span>
                  </p>
                  <p>
                    <span>North Point Business Park</span>
                  </p>
                  <p>
                    <span>New Mallow Road</span>
                  </p>
                  <p>
                    <span>Cork T23AT2P</span>
                  </p>
                  <p>
                    <span>Ireland</span>
                  </p>
                  <p>
                    <span />
                  </p>
                </td>
              </tr>
            </tbody>
          </table>

          <p>
            <span />
          </p>

          <p>
            <span />
          </p>
        </div>
      </AMPPageSection>
    </AMPPage>
  );
}
